import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import { TextDiff } from './TextDiff';

import './FullTextDiffRenderer.less';

const block = bemBlock('full-text-diff-renderer');

export const FullTextDiffRenderer = React.memo(
  ({
    highlightedStringLengthLimit,
    value,
    referenceValue,
  }: {
    highlightedStringLengthLimit: number;
    value: string;
    referenceValue: string;
  }) => {
    const skipDiffHighlighting = value === referenceValue || highlightedStringLengthLimit === 0;

    const partToHighlight = React.useMemo(
      () => value.slice(0, highlightedStringLengthLimit),
      [value, highlightedStringLengthLimit],
    );
    const referencePartToHighlight = React.useMemo(
      () => referenceValue.slice(0, highlightedStringLengthLimit),
      [referenceValue, highlightedStringLengthLimit],
    );
    const restPart = React.useMemo(
      () => value.slice(highlightedStringLengthLimit),
      [value, highlightedStringLengthLimit],
    );

    const renderContent = () => {
      if (skipDiffHighlighting) {
        return <span data-role="full-text-diff-reference-value">{value}</span>;
      }

      return (
        <>
          <TextDiff value={partToHighlight} referenceValue={referencePartToHighlight} />
          {restPart}
        </>
      );
    };

    return (
      <div data-role="full-text-diff-renderer" className={block('wrapper')}>
        {renderContent()}
      </div>
    );
  },
);

FullTextDiffRenderer.displayName = 'FullTextDiffRenderer';
